const styleRow: React.CSSProperties = {
    fontSize: '1em'
};
const styleRowSelect: React.CSSProperties = {
    fontSize: '1em',
    background: '#aaffff'
};
const styleTable: React.CSSProperties = {
    border: '1px solid #9F9F9F',
    borderCollapse: 'collapse',
    width: '100%'
};
const styleCell: React.CSSProperties = {
    border: '1px solid #9F9F9F'
};
const styleInput: React.CSSProperties = {
    width: '100%',
    boxSizing: 'border-box'
};

export { styleCell, styleInput, styleRow, styleRowSelect, styleTable };
